import './sass/01-settings/_tailwind.scss'
import './sass/style.scss'

import SiteHeader from './js/modules/SiteHeader/SiteHeader'
import { MobileMenu } from './js/modules/MobileMenu'
import { WindowWidth } from './js/utils/WindowWidth'
import { smoothScroll } from './js/modules/scroll'
import { toFullWidthInWrapper } from './js/utils/utils'
import { VideoSlider } from '../components/VideoSlider/VideoSlider'
import { CountingNumbers } from '../components/CountingNumbers/CountingNumbers'
import { LatestPosts } from '../components/LatestPosts/LatestPosts'
import { Team } from '../components/Team/Team'
import { LogoList } from '../components/LogoList/LogoList'
import { DarkCountingNumbers } from '../components/DarkCountingNumbers/DarkCountingNumbers'
import Filters from '../components/filters/ts/Filters'
import ContactForm from '../components/ContactForm/ContactForm'
import { CreateGoogleMaps } from './js/modules/CreateGoogleMaps'
import { SpinnerWithList } from '../components/SpinnerWithList/SpinnerWithList'

new WindowWidth()

window.addEventListener('load', () => {
  new SiteHeader()
  new MobileMenu()
  smoothScroll()
  toFullWidthInWrapper()
  new VideoSlider('.video-slider__container')
  new CountingNumbers()
  new Team('.team__container', '.team__navigation .js-next', '.team__navigation .js-prev')
  new LogoList('.logolist__container')
  new DarkCountingNumbers()
  new ContactForm()
  new SpinnerWithList()
  document.querySelectorAll('.js-latest-posts').forEach(item => new LatestPosts(item as HTMLElement))
  document.querySelectorAll('.filters-form').forEach(filterForm => new Filters(filterForm as HTMLFormElement))
  document.querySelectorAll('.js-google-map').forEach(item => new CreateGoogleMaps(item as HTMLElement))

  window.addEventListener('resize', () => {
    new MobileMenu()
  })
})
